// extracted by mini-css-extract-plugin
export var centerText = "_5o-8";
export var container = "_5o-0";
export var doughnutContainer = "_5o-7";
export var legend = "_5o-a";
export var legendItemColorDisplay = "_5o-b";
export var legendItemLabel = "_5o-d";
export var legendItemValue = "_5o-c";
export var lg = "_5o-5";
export var maxWidth = "_5o-9";
export var md = "_5o-4";
export var responsive = "_5o-6";
export var sm = "_5o-3";
export var xs = "_5o-2";
export var xxs = "_5o-1";